import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  IconButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaChevronDown, FaWhatsapp } from 'react-icons/fa';
import whatsappConfig from '../../../../../../config/whatsapp.config';

const { messageTemplates: MESSAGE_TEMPLATES } = whatsappConfig;

/**
 * Component to display preset message templates
 */
const PresetMessages = ({ 
  setMessage, 
  handleSendIntroMessage = null,
  isSending = false, 
  chatTarget = 'personal',
  hasMessages = false
}) => {
  const headerBg = useColorModeValue('#123d2a', '#2f3436');
  const headerText = useColorModeValue('white', 'white');
  const menuHoverBg = useColorModeValue('gray.100', 'gray.700');

  const handleSelectTemplate = (template) => {
    if (template && template.text) {
      // Use void to ensure we don't return anything from this function
      void setMessage(template.text);
      // Focus the input field after selecting a template
      setTimeout(() => {
        document.querySelector('textarea[aria-label="Type a message"]')?.focus();
      }, 100);
    }
  };

  return (
    <>
      <Menu closeOnSelect={true}>
        <MenuButton
          as={Button}
          size="sm"
          leftIcon={<FaChevronDown />}
          variant="outline"
          mr={2}
          mb={2}
        >
          Templates
        </MenuButton>
        <MenuList zIndex={10}>
          {MESSAGE_TEMPLATES.map((template) => (
            <MenuItem
              key={template.id}
              onClick={() => handleSelectTemplate(template)}
              _hover={{ bg: menuHoverBg }}
            >
              {template.title}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>

      {handleSendIntroMessage && chatTarget === 'personal' && !hasMessages && (
        <Button
          size="sm"
          leftIcon={<FaWhatsapp />}
          bg={headerBg}
          color={headerText}
          mr={2}
          mb={2}
          onClick={handleSendIntroMessage}
          isLoading={isSending}
          loadingText="Sending..."
        >
          Send All Intro Messages
        </Button>
      )}
    </>
  );
};

export default PresetMessages;
